// Checkbox.js

import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';

const Checkbox = ({ onChange, text, svgClass, mainClass, svgContainerClass, textClass, defaultValue = false, disabled = false }) => {
  const [checked, setChecked] = useState(false);

  useEffect(() => {
    setChecked(defaultValue);
  }, [defaultValue]);

  const handleClick = () => {
    if (!disabled) {
      const newValue = !checked;
      setChecked(newValue);
      onChange(newValue);
    }
  };

  return (
    <div
      className={`flex cursor-pointer ${mainClass}`}
      onClick={handleClick}
      role="checkbox"
      tabIndex="0"
      aria-checked={checked}
      onKeyDown={(e) => {
        if (e.key === 'Enter' || e.key === ' ') {
          e.preventDefault();
          handleClick();
        }
      }}
    >
      <div className={`${svgContainerClass}`}>
        {checked ? (
          <svg className={`${svgClass}`} viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
            <rect width="32" height="32" rx="4" fill="#B48658" />
            <path d="M24 10L13 21L8 16" stroke="white" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
          </svg>
        ) : (
          <svg className={`${svgClass}`} viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
            <rect x="0.5" y="0.5" width="31" height="31" rx="3.5" fill="white" />
            <rect x="0.5" y="0.5" width="31" height="31" rx="3.5" stroke="#ABABAB" />
          </svg>
        )}
      </div>
      {
        text && (
          <p className={`${textClass}`}>{text}</p>
        )
      }
    </div>
  );
};

Checkbox.propTypes = {
  onChange: PropTypes.func.isRequired,
  text: PropTypes.string,
  svgClass: PropTypes.string,
  mainClass: PropTypes.string,
  svgContainerClass: PropTypes.string,
  textClass: PropTypes.string,
  defaultValue: PropTypes.bool,
  disabled: PropTypes.bool,
};

export default Checkbox;
